import { Tooltip } from '@material-ui/core';
import React from 'react';
import { white50 } from '../../Styles/Colours';
import { Button, ButtonMode, ButtonVariant } from '../Button';
import { StyledDialog } from '../Dialog/StyledDialog';
import { StyledDialogButton } from '../Dialog/StyledDialogButton';
import { StyledDialogContent } from '../Dialog/StyledDialogContent';
import { CloseIcon } from '../Icons';
import styles from './DeleteDialog.module.css';
export var DeleteDialog = function (props) {
    var actionButtons = [
        React.createElement(StyledDialogButton, { mode: ButtonMode.solid, variant: ButtonVariant.light, key: 'cancel', onClick: props.onCancel, width: 94, testId: props.testId + "-cancel" }, "Cancel"),
        React.createElement(StyledDialogButton, { key: 'delete', testId: props.testId + "-ok", onClick: props.onOk, width: 94, variant: ButtonVariant.danger }, "Delete")
    ];
    return (React.createElement(StyledDialog, { open: true, size: 'xxxs', modal: true, titleComponent: React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.title }, props.title),
            React.createElement("div", { className: styles.close },
                React.createElement(Tooltip, { title: 'Close' },
                    React.createElement("span", null,
                        React.createElement(Button, { iconOnly: true, onClick: props.onCancel, mode: ButtonMode.text, noShadowOnHover: true, subtleShadeOnHover: true, testId: props.testId + "-close" },
                            React.createElement(CloseIcon, { size: '24', color: white50, noPadding: true })))))), testId: props.testId, actions: actionButtons, onRequestClose: props.onCancel, contentComponent: React.createElement(StyledDialogContent, { noPadding: true },
            React.createElement("div", { className: styles.contents }, props.children)) }));
};
